var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"my-10",attrs:{"src":require("@/assets/images/logo_full.png"),"height":"250","contain":""}}),_c('p',{staticClass:"text-center text-h6 font-weight-bold"},[_vm._v("Cette page n'existe pas.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }